/// <reference path="../../../app.definition.ts" />
import angular from 'angular';
import { Util } from '../../util';
import { FrozenStatusEnum, TeamTypeEnum } from '../../model/subject';
export class ToggleTeamFreezeController {
    config;
    refText = '';
    reasonToUnfreeze = '';
    verbiage;
    isFreezing;
    showErr = false;
    confirmText = "";
    isProcessing;
    errMsg = "";
    static $inject = ['$uibModalInstance', 'ApiAdapterService', 'PopUpService', 'SubjectService', 'CacheService', 'team'];

    constructor(private $uibModalInstance, private ApiAdapterService, private PopUpService, private SubjectService, private CacheService, private team) {
        var textConfig = Util.getTextsForToggleTeamFreeze();
        // based on this text1 and text2 the final verbiage would be displayed on screen
        var obj = { text1: '', text2: '' };
        var fullName = team.firstName.trim() + ' ' + team.lastName.trim();
        this.isFreezing = !team.isFrozen;
        if (this.isFreezing) {
            this.config = textConfig.freeze;
            if (team.subjectTypeId == TeamTypeEnum.PROJECT) {
                this.refText = "Freeze Team";
                obj.text1 = "this Project";
            } else if (team.teamType == TeamTypeEnum.STUDENT || team.subjectTypeId == TeamTypeEnum.CARE_RECIEPIENT) {
                this.refText = fullName;
                obj.text1 = "<span class='htext'>" + team.firstName + "'s </span>";
                obj.text2 = "the name ";
            }
            obj.text2 += "<span class='htext'>" + this.refText + "</span>";
            this.errMsg = new String(this.config.errMessage).interpolate({ refText: this.refText });
        } else {
            this.config = textConfig.unfreeze;
            if (team.subjectTypeId == TeamTypeEnum.PROJECT) {
                obj.text1 = "the " + team.projectName + " Project Team";
            } else if (team.teamType == TeamTypeEnum.STUDENT || team.subjectTypeId == TeamTypeEnum.CARE_RECIEPIENT) {
                obj.text1 = "<span class='htext'>" + fullName + "'s</span> Team";
            }
        }
        this.verbiage = new String(this.config.message).interpolate(obj);
    }

    close = (): void => {
        this.isProcessing = "Processing...";
        var team = {
            subjectId: this.team.subjectId,
            status: "",
            message: ""
        }

        if (this.isFreezing) {
            team.status = FrozenStatusEnum.FREEZE;
        } else {
            team.status = FrozenStatusEnum.UNFREEZE;
            team.message = this.reasonToUnfreeze.trim();
        }
        this.ApiAdapterService.updateSubject(team, this.CacheService.getPassword()).then((s) => {
            if (this.isFreezing) {
                // in case of unfreeze no need to update the following thing
                this.team.isFrozen = s.isFrozen;
                this.team.frozenDate = s.frozenDate;
                this.team.frozenTeamDetails = s.frozenTeamDetails;
                this.SubjectService.updateSubject(this.team.subjectId, this.team);
            } else {
                this.PopUpService.openInformationModal(Util.TEAM_THAWED_REQ_SUBMITTED);
            }
        }).catch((e) => {
            this.PopUpService.openInformationModal("Something went wrong. Please try again later.");
        }).finally(() => {
            this.isProcessing = false;
            this.$uibModalInstance.close({ team: this.team, isFreezing: this.isFreezing });
        });
    }

    cancel = (): void => {
        this.$uibModalInstance.dismiss();
    }

    validateText = (event) => {
        var code = event.which || event.keyCode;
        if (code === 13) { // if hits enter then
            this.showErr = (this.confirmText != this.refText);
        }
    }
}
angular.module('eCareVault.common.popUp')
    .controller('ToggleTeamFreezeController', ToggleTeamFreezeController);
